// extracted by mini-css-extract-plugin
export default {"active":"Navbar_active__EaWMg","default":"Navbar_default__Cd6vC"};